export function updateProgressImportBroadcastList(data) {
  return {
    type: '@BROADCAST_LIST/UPDATE_PROGRESS_IMPORT',
    payload: data
  };
}
